import { DataviewerControllerService } from 'src/app/shared/services/dataviewer-controller.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'wol-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() filename: string;

  constructor(public dvc: DataviewerControllerService) { }

  ngOnInit() {
  }

}
